import { roleHasPermission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";

export function useExportPermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];

  return {
    canRead: roleHasPermission(role, "exports:read"),
    canExportPayroll: roleHasPermission(role, "exports:full_payroll"),
    canExportAudit: roleHasPermission(role, "audit:read"),
    role,
  };
}
